import Abstract from "../../abstract-view/abstract.js";

export default class Container extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._buttonElement = null;
    this._titleWrapperElement = null;
    this._listElement = this.getListElement();

    this._buttonClickHandler = this._buttonClickHandler.bind(this);
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`.subcategory-current__button`);
    }

    return this._buttonElement;
  }

  getTitleWrapperElement() {
    this._titleWrapperElement = this._element.querySelector(`.subcategory-current-wrapper`);

    return this._titleWrapperElement;
  }

  getListElement() {
    if (!this._listElement) {
      this._listElement = this._element.querySelector(`.subcategories-list`);
    }

    return this._listElement;
  }

  isActive() {
    return this.getTitleWrapperElement().classList.contains(`subcategory-current-wrapper_active`);
  }

  activate() {
    if (this.getButtonElement()) {
      this.getButtonElement().classList.add(`${this.getButtonElement().classList[0]}_active`);
    }


    if (this.getTitleWrapperElement()) {
      this.getTitleWrapperElement().classList.add(`${this.getTitleWrapperElement().classList[0]}_active`);
    }
  }

  deactivate() {
    if (this.getButtonElement()) {
      this.getButtonElement().classList.remove(`${this.getButtonElement().classList[0]}_active`);
    }


    if (this.getTitleWrapperElement()) {
      this.getTitleWrapperElement().classList.remove(`${this.getTitleWrapperElement().classList[0]}_active`);
    }
  }

  setButtonClickHandler(callback) {
    if (!this.getButtonElement()) {
      return;
    }

    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._buttonClickHandler);
  }

  _buttonClickHandler() {
    this._callback.buttonClick();
  }
}
